import SearchIcon from "@mui/icons-material/Search";
import {
  Card,
  Grid2,
  InputAdornment,
  ListItemText,
  TextField,
} from "@mui/material";
import List, { ListProps } from "@mui/material/List";
import { GridColDef, GridFilterModel } from "@mui/x-data-grid";
import React, { forwardRef, useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { CVirtualizedList } from "./c-virtualized-list.component";

export interface VDTableMobileProps<T> extends ListProps {
  data?: T;
  columns: readonly GridColDef[];
  filterModel: GridFilterModel;
}

export const CTableMobile = React.memo(
  forwardRef<HTMLUListElement, VDTableMobileProps<any>>((props, ref) => {
    const [filterModel, setFilterModel] = useState<string[]>([]);

    const filterData = useMemo(() => {
      return props.data?.filter((item: any) => {
        if (filterModel && filterModel.length > 0) {
          return filterModel.some((value) =>
            Object.values(item).some((field) => {
              if (typeof field === "string") {
                return field.includes(value);
              }
              return false;
            })
          );
        }
        return true;
      });
    }, [props.data, filterModel]);

    const renderSecondaryCell = useCallback((item: any, cols: GridColDef) => {
      if (cols.renderCell) {
        return cols.renderCell({ row: item, ...item });
      }

      if (typeof item[cols.field] === "string") {
        return item[cols.field];
      }

      return "";
    }, []);

    return (
      <Grid2 container flexDirection="column">
        <Grid2 size={{ xs: 12 }}>
          <TextField
            label="Search"
            variant="standard"
            fullWidth
            onChange={(e) => {
              setFilterModel(
                e.target.value
                  .split(",")
                  .map((value) => value.trim())
                  .filter((value) => value)
              );
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid2>
        <Grid2 mt={2}>
          <CVirtualizedList
            data={filterData}
            height={80}
            rowRenderer={(params) => {
              return (
                <Card
                  sx={{
                    padding: "20px",
                    width: "100%",
                  }}
                >
                  <Grid2
                    container
                    spacing={2}
                    flexDirection="column"
                    sx={{ width: "100%" }}
                  >
                    <Grid2 size={{ xs: 12 }} flexDirection="column">
                      {props.columns.map((column) => (
                        <Grid2
                          key={`ID: ${filterData[params.index].id} column: ${
                            column.field
                          }`}
                        >
                          <ListItemText
                            primary={column.headerName}
                            secondary={renderSecondaryCell(
                              filterData[params.index],
                              column
                            )}
                          />
                        </Grid2>
                      ))}
                    </Grid2>
                  </Grid2>
                </Card>
              );
            }}
          />
        </Grid2>
      </Grid2>
    );
  })
);

const ListStyle = styled(List)`
  width: 100%;
`;
